<div class="container">
    <div class="div-sub-titulo">
        <div class="div-svg">
            <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72" fill="none">
                <path
                    d="M57 9H15C11.7 9 9 11.7 9 15V57C9 60.3 11.7 63 15 63H57C60.3 63 63 60.3 63 57V15C63 11.7 60.3 9 57 9ZM57 57H15V15H57V57ZM21 30H27V51H21V30ZM33 21H39V51H33V21ZM45 39H51V51H45V39Z"
                    fill="#00806F" />
            </svg>
        </div>
        <div class="div-bem-vindo">
            Bem-vindo(a)!
        </div>
    </div>

    <div class="div-conteudo" style="text-align: justify;">
        <div style="font-weight: 700; text-align: justify;">
            Queremos te ouvir! A POA ajuda a tornar a sua experiência em sala de aula mais produtiva e a melhorar de forma contínua o trabalho da equipe escolar: professor, coordenador e orientador. Vamos começar?
        </div>
        <br /><br />
        <div><span style="font-weight: 700;">Instruções:</span></div>
        <ul>
            <li>
                Para enviar suas respostas, você precisa responder à avaliação de todos os professores e clicar em 
                <span style="font-weight: 700;">"Finalizar POA"</span>;
            </li>
            <li>
                Após avaliar um professor, clique em <span style="font-weight: 700;">"Salvar avaliação"</span>;
            </li>
            <li>
                Se desejar reiniciar a avaliação de um professor, clique em <span style="font-weight: 700;">"Cancelar"</span>.
            </li>
        </ul>
        Não deixe de compartilhar sua opinião de forma mais detalhada em “Comentários”. Sua participação faz a diferença! 
        <br /><br />
    </div>

    <div class="div-button">
        <app-button (click)="iniciarPoa()">{{ 'questionario.iniciar' | translate }}</app-button>
    </div>
</div>